import { replace } from 'connected-react-router';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { DEFAULT } from '../../../routes/paths';

const NotFound = ({ goToHomePage }) => (
  <div className="page-not-found">
    <div className="container--fixed">
      <h1 className="page-not-found__header">
        Page not found
      </h1>
      <p className="page-not-found__paragraph">
        Don’t worry – you may have typed the web address incorrectly,
        or the page you were looking for may have been moved,
        updated or deleted.
      </p>
      <Button onClick={goToHomePage} className="page-not-found__button">
        Go to home page
      </Button>
    </div>
  </div>
);

NotFound.propTypes = {
  goToHomePage: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  goToHomePage: () => replace(DEFAULT)
};

export default connect(null, mapDispatchToProps)(NotFound);
